import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { AI_COMPANION } = ANALYTICS_CATEGORIES;
const { CLICK } = SNOWPLOW_EVENTS;

interface TriggerAiCompanionExistingChatClickedEventParams {
	conversationId: string;
}

export const triggerAiCompanionExistingChatClickedEvent = ({
	conversationId,
}: TriggerAiCompanionExistingChatClickedEventParams): void => {
	const eventPayload = getSnowplowEventPayload({
		category: AI_COMPANION,
		customData: { label: conversationId },
		name: 'dlr_ai_companion_existing_chat_clicked',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
